/* ──────────────────────────────────────────────────────────────────────
   Triple Y · משפט Active New: מציג ומסתיר בכל החלפת ווריאנט. 24.09.2026
   🔴 product-info.js אינו מרנדר מחדש את האזור הזה, ולכן המאזין כאן.
      המזהים של Active New נכתבו בשרת ב-data-ty-aln, מופרדים בפסיק.
   ────────────────────────────────────────────────────────────────────── */
(() => {
  'use strict';
  if (window.__tyAlnInit) return;
  window.__tyAlnInit = true;

  function apply(variantId, sectionId) {
    if (!variantId) return;
    /* רק בתוך הסקשן שהחליף ווריאנט, כדי לא לגעת במוצר אחר בדף (חלון הוספה מהירה) */
    const scope = (sectionId && document.querySelector('[data-section="' + sectionId + '"]')) || document;
    const key = ',' + String(variantId) + ',';
    scope.querySelectorAll('[data-ty-aln]').forEach((el) => {
      const on = (',' + (el.getAttribute('data-ty-aln') || '')).indexOf(key) >= 0;
      el.hidden = !on;
      if (!on) {
        const btn = el.querySelector('.ty-condhelp__btn');
        const bub = el.querySelector('.ty-condhelp__bubble');
        if (btn) btn.setAttribute('aria-expanded', 'false');
        if (bub) bub.hidden = true;
      }
    });
  }

  function start() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false;
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const v = event && event.data && event.data.variant;
      apply(v && v.id, event && event.data && event.data.sectionId);
    });
    return true;
  }
  if (!start()) document.addEventListener('DOMContentLoaded', start, { once: true });
})();
